import { Helpers } from './helpers/Helpers';
import { Module } from './Module';
import { SiteUrlMatcherFactory } from './services/SiteUrlMatcherFactory';
import { StartPageService } from './services/StartPageService';

interface ISiteStateParams extends ng.ui.IStateParamsService {
  siteUrlName: string;
}

Module.instance().config(<any[]>[
  '$stateProvider',
  '$urlRouterProvider',
  'SiteUrlMatcherFactoryProvider',
  (
    $stateProvider: ng.ui.IStateProvider,
    $urlRouterProvider: ng.ui.IUrlRouterProvider,
    siteUrlMatcherFactory: SiteUrlMatcherFactory) => {
    const siteUrl = (url: string) => siteUrlMatcherFactory.compile(url);

    /**
     * This function creates a redirect handler for a site url. See $urlRouterProvider documentation for details.
     * The general use case for this function is to redirect differently based on feature flags.
     */
    function customSiteUrlRedirect(getRedirectedUrl: ($match: any) => string | false) {
      return [ '$match', ($match: any) => {
        const redirectedUrl = getRedirectedUrl($match);
        // If the redirected URL is false, don't redirect
        if (redirectedUrl === false) {
          return false;
        }
        return siteUrl(redirectedUrl).format($match);
      }];
    }

    /**
     * A simple URL redirect handler, which redirects to a static URL.
     */
    function siteUrlRedirect(url: string) {
      return customSiteUrlRedirect(() => url);
    }

    const rootSiteUrlRedirect =
    ['$match',
    'StartPageService',
    '$location',
      ($match: ISiteStateParams,
        startPageService: StartPageService,
        $location: ng.ILocationService) => {
        const noSiteInUrl = !$match.siteUrlName;
        const params = Helpers.serialize($location.search());
        const startPage = (noSiteInUrl)
            // When going to the root url ('/') go to the start page for the site we are currently on.
            ? startPageService.getCurrentUserStartPageForCurrentSite()
            // When going to the root url for an explicit site ('/site/foo'), go to the start page on that site
            : startPageService.getCurrentUserStartPageForSite($match.siteUrlName);
        return startPage + (params ? (/\?/.test(startPage) ? '&' : '?') + params : '');
      }
    ];

    // Redirects for default related content types
    // TODO: perhaps add these as part of state creation helper methods
    $urlRouterProvider
      .when(siteUrl(''), rootSiteUrlRedirect)
      .when(siteUrl('/'), rootSiteUrlRedirect)
      .when(siteUrl('/{type}/'), siteUrlRedirect('/{type}'))
      .when(siteUrl('/{type}/{id}/'), siteUrlRedirect('/{type}/{id}'));

    // !!! ATTENTION !!!
    // If you changed the url scheme of user or user setting,
    // make sure to also update the user setting url generation code in:
    // \workgroup\vqlweb\scriptsharp\src\Authoring\ViewModels\AuthoringMastheadViewModel.cs

    // Adding an extra child state underneath the abstract one here to
    // avoid remounting of the space router when changing urls that are
    // on this state
    $stateProvider
      .state('main.site.reactrouter', {
        template: '<div class="tb-fill"><tb:site-space-router/></div>', // SiteSpaceRouter.tsx via angularDirectives.ts
        abstract: true
      }).state('main.site.reactrouter.base', {
        url: siteUrl(`/{space:(?:jobs|settings|extensions|bridge|authentication|catalog|dataAlert|search|schedules|explore|flows|workbooks|views|projects|dataRoles|analysis|home|metrics|recommendations|redirect_to_view|redirect_to_favorite_view|redirect_to_project|redirect_to_workbook|redirect_to_datasource|redirect_to_removed_datasource|redirect_to_data_role|redirect_to_flow|groups|user|users|favorites|recents|datasources|status|tasks|redirect_to_metric)}`),
      })
      .state('main.site.reactrouter.base.subspace', {
        url: '/*subspace'
      });
  }
]);
